import React from 'react';

export default function Logout() {
    localStorage.removeItem('token');
    // Purge aussi la sélection persistée du dashboard (dates + mode de comparaison).
    localStorage.removeItem('dashStartDate');
    localStorage.removeItem('dashEndDate');
    localStorage.removeItem('dashComparison');
    window.location.href="/";

    return(
        <h2>Déconnexion</h2>
    );
}